<template>
    <div class="inner-wrapper">
      <div class="editor-wrapper" v-show="viewMode === 'list'">
        <div class="title-wrapper">
          <span>{{base_info.title_ch}}</span>
        </div>
        <van-search placeholder="请输入委托单编号关键词" v-model="optionData.project_display_no" @search="onSearch" />
        <van-search placeholder="请输入报告编号关键词" v-model="optionData.report_display_no" @search="onSearch" />
        <van-list
          v-model="reportTable.loading"
          :finished="reportTable.finished"
          finished-text="没有更多了"
          :error.sync="reportTable.error"
          error-text="请求失败，点击重新加载"
          @load="onLoad"
        >
          <van-cell
            v-for="item in reportTable.tivdata"
            :key="item.report_display_no+'verify'"
            :title="item.report_display_no+item.alter_mark+''"
          >
            <div slot="label">
              <div>{{item.company_name}}</div>
              <div>
                <span class="cell-item">{{item.reporter}}</span>
                <span class="cell-item">{{item.report_date}}</span>
              </div>
            </div>
            <div class="cell-buttons">
              <van-button size="mini" type="info" @click.stop="viewReport(item)">查看报告</van-button>
              <van-button size="mini" type="primary" @click.stop="uploadRecord(item)">原始记录</van-button>
            </div>
          </van-cell>
        </van-list>
      </div>
      <div class="report-wrapper" v-show="viewMode === 'report'">
        <van-nav-bar
          :title="currentReport.report_display_no+currentReport.alter_mark+''"
          left-text="返回"
          left-arrow
          @click-left="onClickBack"
          fixed
        />
        <report-view :report_no="currentReport.report_no"></report-view>
      </div>
      <div class="record-wrapper" v-show="viewMode === 'record'">
        <van-nav-bar
          title="原始记录"
          left-text="返回"
          left-arrow
          @click-left="onClickBack"
          fixed
        />
        <van-cell :title="currentReport.report_display_no+currentReport.alter_mark+''" title-class="record-report-title" />
        <div class="record-section">
          <div class="record-uploader-wrapper">
            <van-uploader
              v-model="recordImages"
              :after-read="afterRead"
              :before-delete="confirmDeleteRecordImage"
              upload-text="上传原始记录"
              :max-count="20"
            />
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import reportView from "./ReportView.vue";
import Compressor from 'compressorjs';

let userToken = localStorage.getItem("current_user_token");
let authData = JSON.parse(localStorage.getItem("authData"));

const OPTIONDATA = {
  test_catagory:[
    {text:'全部类别',value:''},
    {text:'金相',value:'J'},
    {text:'力学',value:'L'},
    {text:'化学',value:'H'},
    {text:'铁路',value:'T'},
    {text:'综合',value:'Z'},
    ],
  report_stat:[
    {text:'全部状态',value:''},
    {text:'待接收',value:'待接收'},
    {text:'待出具',value:'待出具'},
    {text:'待提交',value:'待提交'},
    {text:'待修改',value:'待修改'},
    {text:'待审核',value:'待审核'},
    {text:'待批准',value:'待批准'},
    {text:'已完成',value:'已完成'},
    {text:'已打印',value:'已打印'},
    {text:'已寄出',value:'已寄出'},
    {text:'已作废',value:'已作废'},
  ],
  period:[
    {text:'全部限期',value:''},
    {text:'当前逾期',value:'-1'},
    {text:'接近逾期',value:'1'},
    {text:'历史逾期',value:'history-1'},
  ],
  date_type:[
    {text:'要求日期',value:'demand_date'},
    {text:'出具日期',value:'report_date'},
    {text:'审核日期',value:'verify_date'},
    {text:'批准日期',value:'approve_date'},
    {text:'委托日期',value:'create_date'},
  ],
  language:[
    {text:'全部语言',value:''},
    {text:'English',value:'English'},
    {text:'中文(简体)',value:'中文(简体)'},
  ],
  stamp:[
    {text:'全部印章',value:''},
    {text:'有CNAS无CMA',value:'cnas'},
    {text:'有CMA无CNAS',value:'cma'},
    {text:'CNAS/CMA均有',value:'+cnas+cma'},
    {text:'CNAS/CMA均无',value:'-cnas-cma'},
  ],
  order:[
    {text:'默认排序',value:''},
    {text:'要求日期',value:'demand'},
    {text:'委托日期',value:'create'},
    {text:'完成日期',value:'complete'},
  ],
  esc:[
    {text:'排序方向',value:'DESC'},
    {text:'倒序',value:'DESC'},
    {text:'顺序',value:'ESC'}
  ]
}

function optionDataFac(){
  return {
    project_display_no:'',
    report_display_no:'',
    test_catagory:OPTIONDATA.test_catagory[0].value,
    report_stat:OPTIONDATA.report_stat[0].value,
    period:OPTIONDATA.period[0].value,
    date_type:OPTIONDATA.date_type[0].value,
    start_date:'',
    end_date:'',
    if_ac:false,
    completed:false,
    keyword:'',
    company_name:'',
    standard:'',
    language:'',
    stamp:'',
    order:'',
    esc:OPTIONDATA.esc[0].value
  };
}

export default {
  name: "reportVaWithRecord",
  components: {
    reportView,
  },
  props: {
    base_info: {
      type: Object,
      default() {
        return {
          title_ch: "",
          post_url: "",
          askData: ""
        };
      }
    },
  },
  data() {
    return {
      optionData:optionDataFac(),
      reportTable: {
        loading: false,
        finished: false,
        error: false,
        Tpage: {
          currentPage: 1,
          currentSize: 20
        },
        no_data_text: "",
        totalItems: 0,
        tivdata: [
        ]
      },
      viewMode:'list',
      currentReport:{},
      recordImages: [],
    };
  },
  watch: {
  },
  computed: {},
  created() {
  },
  methods: {
    onLoad() {
      this.reportTable.loading = true;
      this.$axios
        .post(this.$url + this.base_info.post_url, {
          page: this.reportTable.Tpage,
          userToken: userToken,
          ask_data: this.base_info.askData,
          optionData:this.optionData,
        })
        .then(response => {
          for(let ele of response.data.res_record){
            this.reportTable.tivdata.push(ele);
          }
          if(response.data.res_record.length<this.reportTable.Tpage.currentSize){
            this.reportTable.finished = true
          }
          this.reportTable.loading = false;
          this.reportTable.Tpage.currentPage++;
        });
    },
    onSearch(){
      this.reportTable.tivdata.splice(0,this.reportTable.tivdata.length);
      this.reportTable.Tpage.currentPage = 1;
      this.onLoad();
    },
    viewReport(val){
      this.currentReport = val;
      if(this.currentReport.report_id){
        this.currentReport.report_no = this.currentReport.report_id;
      }
      this.viewMode = 'report';
    },
    uploadRecord(val){
      this.currentReport = val;
      this.viewMode = 'record';
      this.recordImages = [];
      this.fetchRecordImages();
    },
    onClickBack(){
      this.viewMode = 'list';
      this.recordImages = [];
    },
    fetchRecordImages() {
      this.$axios
        .post(this.$url + "/get_report_record_images", {
          userToken: userToken,
          report_id: this.currentReport.report_id
        })
        .then(response => {
          if (response.data.stat === "ok") {
            this.recordImages = response.data.images.map(img => ({
              id: img.id,
              url: this.$fileUrlFac(img.file_url, authData.sfileRight),
              file_url: img.file_url,
              name: img.name,
              isImage: true
            }));
          }
        })
        .catch(error => {
          console.log("获取原始记录失败：" + error);
        });
    },
    afterRead(file, detail) {
      file.status = 'uploading';
      file.message = '上传中...';

      let nativeFile = file.file;

      if (nativeFile.size < 200 * 1024) {
        this.uploadRecordImage(nativeFile, detail.index);
      } else {
        let vm = this;
        new Compressor(nativeFile, {
          quality: 200 * 1024 / nativeFile.size,
          success(result) {
            let compressedFile = new File([result], nativeFile.name, {
              type: nativeFile.type,
              lastModified: Date.now()
            });
            vm.uploadRecordImage(compressedFile, detail.index);
          },
          error(err) {
            console.log(err.message);
            vm.recordImages[detail.index].status = 'failed';
            vm.recordImages[detail.index].message = '压缩失败';
            vm.$toast.fail('图片压缩失败！');
          }
        });
      }
    },
    uploadRecordImage(file, index) {
      let formData = new FormData();
      formData.append('userToken', userToken);
      formData.append('report_id', this.currentReport.report_id);
      formData.append('file', file);

      this.$axios
        .post(this.$url + "/upload_report_record_image", formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        .then(response => {
          if (response.data.stat === 'ok') {
            this.recordImages[index].status = 'done';
            this.recordImages[index].message = '';
            this.recordImages[index].id = response.data.image.id;
            this.recordImages[index].file_url = response.data.image.file_url;
            this.recordImages[index].url = this.$fileUrlFac(response.data.image.file_url, authData.sfileRight);
            this.$toast.success('上传成功！');
          } else {
            this.recordImages[index].status = 'failed';
            this.recordImages[index].message = '上传失败';
            this.$toast.fail(response.data.message || '上传失败！');
          }
        })
        .catch(error => {
          this.recordImages[index].status = 'failed';
          this.recordImages[index].message = '上传失败';
          this.$toast.fail('无法连接到服务器！' + error);
        });
    },
    confirmDeleteRecordImage(file, detail) {
      this.$dialog
        .confirm({
          title: '',
          message: '确认删除本图片？',
          beforeClose: (action, done) => {
            if (action === 'confirm') {
              this.$axios
                .post(this.$url + "/delete_report_record_image", {
                  userToken: userToken,
                  report_id: this.currentReport.report_id,
                  image_id: this.recordImages[detail.index].id
                })
                .then(response => {
                  if (response.data.stat === 'ok') {
                    this.recordImages.splice(detail.index, 1);
                    done();
                    this.$toast.success('删除成功！');
                  } else {
                    done();
                    this.$toast.fail('删除失败！');
                  }
                })
                .catch(error => {
                  done();
                  this.$toast.fail('无法连接到服务器！' + error);
                });
            } else {
              done();
            }
          }
        })
        .catch(() => {});
      return false;
    }
  }
};
</script>
<style scoped>
.inner-wrapper {
  width: 100%;
  background: #f7f7f7;
  min-height:20rem;
}

.title-wrapper {
  text-align: center;
  font-size: 0.8rem;
  color:#999;
  padding: 1rem;
  background: #fff;
  border-bottom:1px solid #f6f6f6;
}

.editor-wrapper {
  width:100%;
}
.cell-item{
  margin-left:0.6rem;
}

.cell-buttons {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  align-items: flex-end;
}

.record-report-title {
  font-weight: 600;
  font-size: 0.9rem;
  text-align: center;
}

.record-section {
  margin-top: 0.5rem;
  background: #fff;
  padding-bottom: 0.5rem;
}

.record-uploader-wrapper {
  padding: 0.5rem 1rem;
}

</style>
